import React, { useState } from "react";
import { ActionIcon, Group, Tooltip } from "@mantine/core";
import { IconAugmentedReality, IconLayoutAlignTop, IconZoomIn } from '@tabler/icons-react';
import { useObjectStore } from "../zustand/objects";
import {
  CHROME_TOOLBAR_ICON_GLYPH,
  chromeToolbarGroupStyle,
  chromeToolbarIconButtonProps,
} from "../utils/editorChromeTheme";

const EditorCameraPresetToolbar = ({ iconColour }) => {
  const [hovered, setHovered] = useState(null);
  const setEditorCameraPreset = useObjectStore((s) => s.setEditorCameraPreset);

  const presets = [
    { key: "perspective", label: "Perspective", icon: IconAugmentedReality },
    { key: "top", label: "Top-down", icon: IconLayoutAlignTop },
    { key: "zoom", label: "Zoomed", icon: IconZoomIn },
  ];

  return (
    <Group
      gap={0}
      align="center"
      wrap="nowrap"
      style={chromeToolbarGroupStyle(iconColour)}
    >
      {presets.map((p) => {
        const Icon = p.icon;
        const isHover = hovered === p.key;
        return (
          <Tooltip key={p.key} label={p.label}>
            <ActionIcon
              variant="transparent"
              onClick={() => setEditorCameraPreset(p.key)}
              onPointerOver={() => setHovered(p.key)}
              onPointerLeave={() => setHovered(null)}
              {...chromeToolbarIconButtonProps(isHover, iconColour, false, true)}
            >
              <Icon
                size={CHROME_TOOLBAR_ICON_GLYPH}
                style={{
                  transform: p.key === "top" ? "rotate(180deg)" : "none",
                }}
              />
            </ActionIcon>
          </Tooltip>
        );
      })}
    </Group>
  );
};

export default EditorCameraPresetToolbar;
